enum ChainId {
  BSC = 56,
  BSC_TESTNET = 97,
  MAINNET = 1,
  RINKEBY = 4,
  POLYGON = 137,
  POLYGON_TESTNET = 80001
}

export default ChainId
